// extracted by mini-css-extract-plugin
export default {"intructions":"ConfirmationNotes-module__intructions--8939","link":"ConfirmationNotes-module__link--f4f0"};